/**
 * Popup d'information au clic sur une carte flash ("Je le veux", voir
 * helpers/ajax.php : theme_render_flash_card()) : le prix affiché est
 * indicatif, on prévient avant de renvoyer vers la prise de rendez-vous.
 *
 * Composant global (comme LoadMore) car les cartes flash apparaissent sur
 * 2 pages (home + page Flash). Délégation d'évènement sur "document" (et
 * non un simple querySelectorAll au chargement, cf. CustomModal.js) : les
 * cartes flash peuvent être injectées après coup en AJAX par LoadMore.js,
 * une liaison ponctuelle au chargement ne les verrait pas.
 *
 * Le lien "Je le veux" garde son vrai href (progressive enhancement : il
 * fonctionne seul si le JS ne se charge pas) — on l'intercepte juste pour
 * ouvrir la popup, et on reporte ce href sur le bouton "D'accord" de la
 * modale avant de l'afficher.
 */
export function render () {

  const modal = document.getElementById('flash-modal')
  if (!modal) return

  const confirmBtn = modal.querySelector('#flash-modal-confirm')

  const open = (href) => {
    if (confirmBtn && href) confirmBtn.href = href
    modal.hidden = false
    document.body.classList.add('-modal-open')
  }

  const close = () => {
    modal.hidden = true
    document.body.classList.remove('-modal-open')
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-modal-open="flash-modal"]')
    if (!trigger) return
    event.preventDefault()
    open(trigger.href)
  })

  modal.querySelectorAll('[data-modal-close]').forEach(el => {
    el.addEventListener('click', close)
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) close()
  })

}
